export function getAframeFont(options = {}) {
  const { fontName = 'roboto', fontWeight = 'bold' } = options;
  const fontPath = `${process.env.PUBLIC_URL}/assets/fonts/${fontName}/${fontWeight}`;
  const font = `${fontPath}-msdf.json`;
  const fontImage = `${fontPath}-msdf.png`;
  return { font, fontImage };
}
